// Formateo de fechas/horas de llamadas en la zona del call center (México).
//
// El backend devuelve los timestamps como UTC real (ISO 8601 con offset). Para
// que la hora mostrada coincida con Genesys y sea independiente de la zona del
// navegador del usuario, SIEMPRE formateamos con timeZone fijo America/Mexico_City.

const LOCAL_TZ = 'America/Mexico_City';

const DEFAULT_OPTS = { timeZone: LOCAL_TZ };

/**
 * Formatea un timestamp (string ISO o Date) en hora local de México.
 * @param {string|number|Date|null|undefined} value
 * @param {Intl.DateTimeFormatOptions} [opts] opciones extra para toLocaleString
 * @returns {string} cadena formateada, o '—' si el valor es vacío/ inválido
 */
export function formatMx(value, opts = {}) {
  if (value == null || value === '') return '—';
  const dt = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(dt.getTime())) return '—';
  return dt.toLocaleString('es-MX', { ...DEFAULT_OPTS, ...opts });
}

export { LOCAL_TZ };
